// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"YV-H3PhmhH1_Zgx7bN1IG","spaceLeft":"_14TQ2xrjAG0E0CcynnEXfx","spaceBoth":"Bj6vTK-GTdQDcBgPfbVCZ","spaceRight":"_1h7_44byzKh6jPrcxj8y_K","modal":"_20HwKygZWxXA2WjpG63G0u","closeModalBtn":"_1qFBHHzv09JUoccKHRX86B","heading":"_3D10lM7AZ3XWu2Y6ZbUQtA"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/modules/_modal.scss
// module id = 284
// module chunks = 0